import { HttpHeaders, HttpResponse, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

export interface cityStateResponse {
  success: boolean;
  state: string;
  city: string;
}

@Injectable({
  providedIn: 'root',
})
export class CityStateInfoService {
  private http = inject(HttpClient);
  endPointCityStateBase: string = '/CityStateInfo';

  complete: boolean = false;

  responseSubject = new BehaviorSubject<cityStateResponse | null>(null);
  response$ = this.responseSubject.asObservable();

  private defaultResponse = {
    success: false,
    state: '',
    city: '',
  };

  cityStateResponse: cityStateResponse = JSON.parse(
    JSON.stringify(this.defaultResponse)
  );

  fetchCityStateInfo(
    formData: unknown
  ): Observable<HttpResponse<cityStateResponse>> {
    return this.http.post<cityStateResponse>(
      environment.apiUrl + this.endPointCityStateBase,
      formData,
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        observe: 'response',
      }
    );
  }

  fetchCityStateInfoNew(formData: unknown) {
    this.http
      .post<cityStateResponse>(
        environment.apiUrl + this.endPointCityStateBase,
        formData,
        {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
          observe: 'response',
        }
      )
      .subscribe({
        next: (res: HttpResponse<cityStateResponse>) => {
          if (res.status === 200 && res.body) {
            this.cityStateResponse = res.body;
            this.responseSubject.next(res.body);
            this.complete = true;
          }
        },
        error: () => {
          this.complete = true;
        },
      });
  }

  reset() {
    this.cityStateResponse = JSON.parse(JSON.stringify(this.defaultResponse));
    this.responseSubject.next(this.cityStateResponse);
    this.complete = false;
  }
}
